import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React from 'react';
import { IStyle } from 'Styles';
import {
  actionButtonsDisable,
  actionButtonsEnable,
  actionButtonStyle,
  iconSize,
} from './Constants';

export interface HeaderBarProps {
  title: string;
  enableEditDelete: boolean;
  disableAdd?: boolean;
  disableEdit?: boolean;
  activeEdit?: boolean;
  outlinedEdit?: boolean;
  disableSetDefaultQuota?: boolean;
  onAdd?: () => void;
  onDelete?: () => void;
  onEdit?: () => void;
  onCopyEmail?: () => void;
  onSetDefaultQuota?: () => void;
}

const HeaderBar = (props: HeaderBarProps) => {
  const {
    title,
    enableEditDelete,
    disableAdd = false,
    disableEdit = false,
    activeEdit = false,
    outlinedEdit = false,
    disableSetDefaultQuota = false,
    onAdd,
    onDelete,
    onEdit,
    onCopyEmail,
    onSetDefaultQuota,
  } = props;
  const headerButtonsContent: RMCustomButtonProps[] = [];

  if (onCopyEmail) {
    headerButtonsContent.push({
      onClick: onCopyEmail,
      isDisabled: false,
      titleTip: 'Copy Emails',
      iconProps: { name: 'Copy', fill: 'white', ...iconSize },
      contentContainerStyle: {
        ...actionButtonStyle,
        backgroundColor: actionButtonsEnable.edit,
      },
    });
  }

  if (onSetDefaultQuota) {
    headerButtonsContent.push({
      onClick: onSetDefaultQuota,
      isDisabled: disableSetDefaultQuota,
      titleTip: 'Set Default Quota',
      iconProps: { name: 'SetDefaultQuota', fill: 'white', ...iconSize },
      contentContainerStyle: {
        ...actionButtonStyle,
        backgroundColor: actionButtonsEnable.edit,
      },
    });
  }

  if (onEdit) {
    headerButtonsContent.push({
      onClick: onEdit,
      isDisabled: disableEdit ? disableEdit : !enableEditDelete,
      titleTip: 'Edit',
      iconProps: {
        name: 'Edit',
        fill: outlinedEdit && !activeEdit ? actionButtonsEnable.edit : 'white',
        ...iconSize,
      },
      contentContainerStyle: {
        ...actionButtonStyle,
        backgroundColor: outlinedEdit && !activeEdit ? 'white' : actionButtonsEnable.edit,
        borderStyle: outlinedEdit && !activeEdit ? 'solid' : 'none',
        borderWidth: outlinedEdit && !activeEdit ? '1px' : '0',
        borderColor: actionButtonsEnable.edit,
        boxSizing: 'border-box',
      },
    });
  }

  if (onAdd) {
    headerButtonsContent.push({
      onClick: onAdd,
      isDisabled: disableAdd,
      titleTip: 'Add',
      iconProps: { name: 'Add', fill: 'white', ...iconSize },
      contentContainerStyle: {
        ...actionButtonStyle,
        backgroundColor: actionButtonsEnable.add,
      },
    });
  }

  if (onDelete) {
    headerButtonsContent.push({
      onClick: onDelete,
      isDisabled: !enableEditDelete,
      titleTip: 'Delete',
      iconProps: { name: 'Delete', fill: 'white', ...iconSize },
      contentContainerStyle: {
        ...actionButtonStyle,
        backgroundColor: enableEditDelete
          ? actionButtonsEnable.delete
          : actionButtonsDisable.delete,
      },
    });
  }
  return (
    <div id="headerbar-wrapper" style={styles.mainContainer}>
      <div id={`headerbar-${title}`} style={styles.title}>
        {title}
      </div>
      <div id="headerbar-buttons" style={styles.headerButtons}>
        {headerButtonsContent.map((headerButton, i) => (
          <RMCustomButton key={`hbrc${i}`} {...headerButton} />
        ))}
      </div>
    </div>
  );
};

const styles: IStyle = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: 'large',
    marginLeft: '2%',
  },
  headerButtons: {
    width: '20%',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    marginRight: '10px',
    justifyContent: 'end',
  },
};
export default HeaderBar;
